/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowsVertical = createReactComponent("outline", "arrows-vertical", "IconArrowsVertical", [["path", { "d": "M8 7l4 -4l4 4", "key": "svg-0" }], ["path", { "d": "M8 17l4 4l4 -4", "key": "svg-1" }], ["path", { "d": "M12 3l0 18", "key": "svg-2" }]]);

export { IconArrowsVertical as default };
//# sourceMappingURL=IconArrowsVertical.mjs.map
